import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../commonUtils";
import Pagination from "../Header/Pagination";
import Header from "../Header/header";
import gridTemplateService from "./gridTemplateService";
import ProjectSummary from "../Projects/projectSummary";
import EditProject from "../Projects/editProject";
import CommonSearch from "../commonSearch/CommonSearch";
import AssetLinking from "../AssetLinking/AssetLinking";
import Generation from "../Generation/Generation";

export default function ProjectGrid(param: any) {
    const [ProjectList, initProjectList] = useState<any>([]);
    const [totalRows, setTotalRows] = useState(0);

    const [gridHeader, initGridHeader] = useState<any>([]);
    const [gridVisibility, initGridVisibility] = useState<any>([]);
    const [GridOriginal, initGridOriginal] = useState<any>([]);
    const [GridOrdering, initGridOrdering] = useState<any>([]);

    let [openProjectSummary, setopenProjectSummary] = useState(false)
    let [openeditProject, setopeneditProject] = useState(false)
    let [openDealsManager, setopenDealsManager] = useState(false)

    let [selectedProjectSummary, setselectedProjectSummary] = useState<any>([]);
    let [openAssetLink, setopenAssetLink] = useState(false);

    let [openGeneration, setopenGeneration] = useState(false);

    var dataLink = "pageSize=10&pageNumber=1";
    var search_For = "";

    useEffect(() => {
        getProjects();
        //search();
    }, []);

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        export: 0,
        searchFor: '',
        sortBy: '',
        sortOrder: ''
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        getProjects()
    }

    const GenerationClose = () => {
        setopenGeneration(false);
    }

    const getProjects = () => {

        for (var i = 0; i < GridOrdering.length; i++) {
            if (GridOrdering[i] === 1) {
                console.log(GridOrdering[i])
                console.log(GridOriginal[i])
                Data.sortBy = GridOriginal[i];
                Data.sortOrder = "ASC";
            }
        }

        gridTemplateService.projectListing(Data).then((res) => {
            CommonUtilities.relativeDataRemapping(res.data, res.headers.original);
            initProjectList(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            setTotalRows(res.totalRows)

            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
            initGridHeader(reMap(res.headers.display));
            initGridVisibility(reMap(res.headers.visible));
            initGridOriginal(reMap(res.headers.original));
            initGridOrdering(reMapOrdering(res.headers.original))

            console.log(reMap(res.headers.display))
        })
    }

    const reMap = (mapReturn: any) => {
        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(value) });
        return tempmapReturn;
    }

    const reMapOrdering = (mapReturn: any) => {
        //0 order by not selected
        // 1 order by 

        var tempmapReturn: any[] = [];
        Object.entries(mapReturn).forEach(([key, value]) => { tempmapReturn.push(0) });

        console.log(tempmapReturn)
        return tempmapReturn;
    }

    const reMapOrderingSet = (index: any) => {
        //0 order by not selected
        // 1 order by 
        for (var i = 0; i < GridOrdering.length; i++) {
            GridOrdering[i] = 0;
        }

        GridOrdering[index] = 1;
        initGridOrdering((existingValues: any) => ([...GridOrdering]));

        getProjects();
    }

    const search = (e: any) => {
        Data.searchFor = e;
        getProjects()
    }

    const ProjectSummaryClose = () => {
        setopenProjectSummary(false)
    }

    const exportProject = (type: any) => {
        ///gridTemplateService.exportProject( { export: true ,exportType : type});
    }

    const saveProjectsGridResult = (filterName: any, status: any) => {
        console.log(filterName)
        console.log(status)
        //gridTemplateService.saveProjectsGridResult({filterName: filterName ,status: status === 0? 1 : 0 ,type: "contactsGridResult"}).then((res) => {getProjects(); } )
    }

    const onSaveUpdate = (e: any) => {
        console.log(e);
        setselectedProjectSummary(e)
    }

    const closeDealsManager = () => {
        setopenDealsManager(false)
    }

    const closeEditForm = () => {
        setopeneditProject(false);
    }

    const SearchForHandle = (e: any, sts: any) => {
        console.log(e)
        console.log(sts)

        if ((sts === true)) {


        }
    }

    const AssetLinkClose = () => {
        setopenAssetLink(false)
    }

    return (
        <div className="ws-12 landingContainer allowHscroll">

            <div className='ws-12 bgWhite'>
                <Header Title={"Projects"} />
            </div>

            <div className='ws-12 mtl pLarge '>
                <CommonSearch SearchForHandle={SearchForHandle} type="projectGrid" title="projectGrid" width="ws-12 pull-left" />
            </div>

            <div className="ws-12 landingPage pm">

                <div className="ws-12">
                    <div className="box-header">
                        <h2 className="pull-left capitalize">Search Results: {totalRows}</h2>

                        <div className="pull-right">
                            <div className="verticalMediumWide hover-box pull-right">
                                <ul className="hover-block textboxDropdownList box pLarge rightReset">

                                    {gridHeader?.map((values: any, index: any) => {

                                        if (values !== 'totalRow' && gridVisibility[index] !== 2) {
                                            return (
                                                <li className="hover-box text-left ws-6 pb">
                                                    <input type="checkbox" checked={gridVisibility[index]} onClick={() => saveProjectsGridResult(GridOriginal[index], gridVisibility[index])} /> {values}
                                                </li>
                                            )
                                        }
                                    })}

                                </ul>
                                <button className="icon-btn info">
                                    <i className="icon-LPurple-Setting m0 p0"></i>
                                </button>
                            </div>

                            <button className="icon-btn edit pull-right mr" onClick={() => { setopenProjectSummary(true); setselectedProjectSummary({}); }}>
                                <i className="icon-files"></i>Add Project
                            </button>

                            <button type="button" className="icon-btn primary"> <i className="icon-download1"></i> Export</button>

                        </div>
                    </div>

                    <div className="box-content allowHscroll">

                        {totalRows > 0 && gridHeader && <table className="newTable">
                            <thead>
                                <tr>
                                    {
                                        gridHeader?.map((values: any, index: any) => {
                                            if (values !== 'totalRow' && gridVisibility[index] === 1) {
                                                return (<>
                                                    <th className="forceSingleLine">
                                                        <span className=" ">{values} </span>

                                                        <a className="pl" onClick={() => reMapOrderingSet(index)}>
                                                            {GridOrdering[index] === 0 && <span style={{ fontSize: "10px" }}>↕</span>}
                                                            {GridOrdering[index] === 1 && <span>↑</span>}
                                                            {GridOrdering[index] === 2 && <span>↓</span>}
                                                            <span className="hide"> {GridOrdering[index]} </span>
                                                        </a>
                                                    </th>
                                                </>)
                                            }
                                        })
                                    }

                                    <th className="forceSingleLine">Operation</th>
                                    <th className="forceSingleLine">  Contracts </th>
                                </tr>
                            </thead>

                            <tbody>

                                {
                                    ProjectList?.map((Datavalues: any, index: any) => {
                                        return (
                                            <tr>
                                                {GridOriginal?.map((values: any, index: any) => {
                                                    if (values !== 'totalRow' && gridVisibility[index] === 1) {
                                                        return (<>
                                                            <td className="forceSingleLine">
                                                                <>
                                                                    {
                                                                        (() => {

                                                                            if (values === "projectCode") {
                                                                                return (

                                                                                    <ProjectSummary projectDetails={Datavalues} />

                                                                                    // <span className="prithiv" onClick={()=>{setopenProjectSummary(true);setselectedProjectSummary({});}}>  
                                                                                    //     {Datavalues[values]}  
                                                                                    // </span>
                                                                                )
                                                                            }

                                                                            if (values === "projectType") {
                                                                                return (
                                                                                    
                                                                                    Datavalues[values]?.toString().split(',')?.map((valueName: any) => {
                                                                                        return (

                                                                                            <a className={"btn-xs ms text-center"}
                                                                                                style={{
                                                                                                    background: CommonUtilities.lookUpTypeList('projectTag', valueName, 'bgColor'),
                                                                                                    color: CommonUtilities.lookUpTypeList('projectTag', valueName, 'fontColor')
                                                                                                }} >
                                                                                                {valueName}
                                                                                            </a>
                                                                                        )
                                                                                    })
                                                                                )

                                                                            }
                                                                        })()
                                                                    }
                                                                </>
 
                                                                <span className={values !== "projectType" && values !== "projectCode" ? "greyDark" : "hide"}>
                                                                    {Datavalues[values]}
                                                                </span>

                                                            </td> </>)
                                                    }
                                                })}

                                                <td width={195} >
                                                    <button className="icon-btn primary pull-left btn-xs" type="button" onClick={() => { setselectedProjectSummary(Datavalues); setopeneditProject(true) }}>
                                                        <i className="icon-pen"></i>
                                                    </button>

                                                    <button className="icon-btn primary pull-left btn-xs" type="button" onClick={() => { setselectedProjectSummary(Datavalues); setopenAssetLink(true) }}>
                                                        <i className="icon-coins"></i>
                                                    </button>

                                                    <button className="icon-btn delete pull-left btn-xs" type="button" >
                                                        <i className="icon-trash"></i>
                                                    </button>
                                                    {
                                                        (() => {
                                                            if (Datavalues['projectType'] && Datavalues['projectType'].includes("Queue Grouping")) {
                                                                return (


                                                                    <button className="icon-btn info pull-left btn-xs" type="button" onClick={() => { setselectedProjectSummary(Datavalues); setopenGeneration(true) }}>
                                                                        <i className="icon-database1"></i>
                                                                    </button>
                                                                );
                                                            }
                                                        })()
                                                    }
                                                </td>
                                                <td>
                                                    <div className="width90">

                                                        <a className="icon-btn edit btn-xs ms">
                                                            <i className="icon-arrow-down"></i>
                                                        </a>

                                                        <a className="icon-btn edit btn-xs ms">
                                                            <i className="icon-download1"></i>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }


                            </tbody>

                        </table>}

                    </div>
                    {
                        (() => {
                            if (totalRows && totalRows > 10) {
                                return <Pagination onChange={handleNameOnChange} totalRows={totalRows} />;
                            }


                        })()
                    }

                </div>
            </div>

            {(() => {
                if (openProjectSummary) {
                    return <ProjectSummary projectDetails={selectedProjectSummary} />
                }

                if (openAssetLink) {
                    return <AssetLinking openAssetLink={openAssetLink} data={selectedProjectSummary} type={"contract"} AssetLinkClose={AssetLinkClose} />
                }

                if (openeditProject) {
                    return <EditProject projectDetails={selectedProjectSummary} openeditProject={openeditProject} closeEditForm={closeEditForm} />
                }

                if (openGeneration) {
                    return <Generation projectDetails={selectedProjectSummary} openGeneration={openGeneration} closeEditForm={GenerationClose} />
                }
            })()}
        </div>
    );
}